import { useEffect, useState } from 'react';

import useDebounce from '../use-debounce';

const useIsMobile = () => {
  const [width, setWidth] = useState(window.innerWidth);
  const debouncedWidth = useDebounce(width, 800);

  function handleWindowSizeChange() {
    setWidth(window.innerWidth);
  }

  useEffect(() => {
    window.addEventListener('resize', handleWindowSizeChange);
    return () => {
      window.removeEventListener('resize', handleWindowSizeChange);
    };
  }, [debouncedWidth]); // eslint-disable-line react-hooks/exhaustive-deps

  return width <= 768;
};

export default useIsMobile;
